// @core/api/endpoints/workflow/import_pipeline_yaml.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ImportPipelineYAMLRequest,
  PipelineResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Import pipeline from YAML
 * Creates a new pipeline from a YAML definition. Validates DAG acyclicity and schema before import.
 */
export async function ImportPipelineYAML(
  data: ImportPipelineYAMLRequest,
  options?: RequestOptions
): Promise<PipelineResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/pipelines/import`;
  const requestOptions = options;
  return client.post<PipelineResponse>(requestPath, data, requestOptions);
}
